<template>
  <div>
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :title="$t('Müqavilə')" :visible.sync="showModal"
      width="80%" top="5vh" append-to-body>
      <el-form ref="serviceCenter" :model="item" label-width="120px" :label-position="labelPosition" size="small" :rules="rules"
        v-loading="loading">
        <div class="row">
          <div class="col-md-6 col-12">
            <el-form-item :label="$t('Təmir_mərkəzi')" prop="name">
              <el-input v-model="item.name"></el-input>
            </el-form-item> 
            <el-form-item :label="$t('Müqavilə_nömrə')" prop="contractNumber">
              <el-input v-model="item.contractNumber"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Məsul_şəxs')"
 prop="contractPerson">
              <el-input v-model="item.contractPerson"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Telefon')" prop="contractPhone">
              <phone v-model="item.contractPhone" />
            </el-form-item>
            <el-form-item :label="$t('Email')" prop="email">
              <el-input v-model="item.email"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Status')" prop="active">
              <el-switch v-model="item.active" :active-value="1" :inactive-value="2">
              </el-switch>
            </el-form-item>
          </div>
          <div class="col-md-6 col-12">
            <el-form-item :label="$t('Bank')" prop="bankId">
              <banks v-model="item.bankId" />
            </el-form-item>
            <el-form-item :label="$t('Service_VÖEN')" prop="serviceTin">
              <el-input v-model="item.serviceTin"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Hesab_nömrə')" prop="accountNumber">
              <el-input v-model="item.accountNumber"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Müqavilə_müddət')">
              <el-date-picker v-model="insPeriod" type="daterange" :start-placeholder="$t('Başlama_tarixi')"
               :end-placeholder="$t('Bitmə_tarixi')" />
            </el-form-item>
            <el-form-item :label="$t('Qeydlər')">
              <el-input v-model="item.notes" resize="none" type="textarea" :rows="3">
              </el-input>
            </el-form-item>
          </div>
        </div>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="clickSave">{{$t('Yadda_saxla')}}</el-button>
        <el-button size="small" @click="showModal = false">{{$t('İmtina')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Banks from "../components/Banks.vue";
import {
  CreateServiceCenter,
  UpdateServiceCenter,
  GetServiceCenter,
} from "../../services/cls";
import { ServiceCenterType } from "../../services/types";
import Phone from "../components/Phone.vue";
import { DateTimeToJson, DateTimeToString,labelPosition } from "../../services/helper";
export default {
  components: {
    Banks,
    Phone
  },
  data() {
    return {
      showModal: false,
      mode: "",
      loading: false,
      item: {},
      insPeriod: [],
      uid: this.$store.state.user.id,
      labelPosition: labelPosition,
      rules: {
        name: [
          {
            required: true,
            message: this.$t('Sütunmütləqdir'),
            trigger: "change",
          },
        ],
        contractPerson: [
          {
            required: true,
            message: this.$t('Sütunmütləqdir'),
            trigger: "change",
          },
        ],
        email: [
          {
            required: true,
            message: this.$t('Sütunmütləqdir'),
            trigger: "change",
          },
        ],
        bankId: [
          {
            required: true,
            message: this.$t('Sütunmütləqdir'),
            trigger: "change",
          },
        ],
        serviceTin: [
          {
            required: true,
            message: this.$t('Sütunmütləqdir'),
            trigger: "change",
          },
        ],
        accountNumber: [
          {
            required: true,
            message: this.$t('Sütunmütləqdir'),
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    new() {
      this.item = new ServiceCenterType();
      this.mode = "New";
      this.showModal = true;
    },
    edit(id) {
      this.loading = true;
      this.activeName = "person";
      this.mode = "Edit";
      this.showModal = true;
      GetServiceCenter(id).then((response) => {
        this.loading = false;
        if (response.data.data) {
          console.log(response.data);
          this.item = response.data.data[0];
          if (this.item.startDate) {
            this.insPeriod = [new Date(this.item.startDate), new Date(this.item.endDate)]
          }
        } else {
          this.showModal = false;
          this.$message({
            type: "warning",
            message: this.$t('Səhv_əməliyyat'),
          });
        }
      });
    },
    clickSave() {
      this.$refs["serviceCenter"].validate((valid) => {
        if (!valid) {
          this.$message({
            type: "warning",
            message: this.$t('Məlumatların_tam_və_düzgün_olmasını_yoxlayın'),
          });
          return false;
        } else {
          this.saveService();
        }
      });
    },
    saveService() {
      this.loading = true;
      let service = Object.assign({}, this.item);
      service.startDate = DateTimeToJson(this.insPeriod[0]);
      service.endDate = DateTimeToJson(this.insPeriod[1]);
      service.commandUserId = this.uid;
      if (this.mode === "New") {
        CreateServiceCenter(service).then((response) => {
          this.loading = false;
          if (response.data.data) {
            if (!response.data.isSuccess) {
              this.$message({
                type: "error",
                message: response.data.errors[0],
              });
            } else {
              this.$emit("saved");
              this.showModal = false;
              this.$message({
                type: "success",
                message: this.$t('Uğurlu_əməliyyat'),
              });
            }
          } else {
            this.$message({
              type: "error",
              message: this.$t('Səhv_əməliyyat'),
            });
          }
        });
      } else {
        UpdateServiceCenter(service).then((response) => {
          this.loading = false;
          
          if (response.data) {
            if (!response.data.isSuccess) {
              this.$message({
                type: "error",
                message: response.data.errors[0]
                  ? response.data.errors[0]
                  : this.$t('Səhv_əməliyyat'),
              });
            } else {
              this.$emit("saved");
              this.showModal = false;
              this.$message({
                type: "success",
                message: this.$t('Uğurlu_əməliyyat'),
              });
            }
          } else {
            this.$message({
              type: "error",
              message: this.$t('Səhv_əməliyyat'),
            });
          }
        });
      }
    },
  },
  mounted() {
  },
};
</script>

<style scoped></style>
